<template>
  <div class="page">
    <div class="flex items-center justify-center v-my-lg v-pt-sm">
      <div class="raise-platform" :style="{ width: raises.length > 4 ? '155px' : '180px'}" :class="{ active: raiseType === item.raiseType }" @click="changeRaise(item)" v-for="item in raises" :key="item.raiseType">
        <div class="raise-platform-logo">
          <img src="~@/assets/images/lingxi_logo.png" v-if="item.raiseType === 1" />
          <img src="~@/assets/images/bytedance_logo.png" v-else-if="item.raiseType === 2" />
          <img src="~@/assets/images/tecent_logo.png" v-else-if="item.raiseType === 3" />
          <img src="~@/assets/images/wb_logo.png" v-else-if="item.raiseType === 4" />
          <img src="~@/assets/images/alipay_logo.png" v-else-if="item.raiseType === 5" />
        </div>
        <div class="raise-platform-names">{{ raisePlatforms[item.raiseType - 1] }}</div>
        <div class="ribbon">
          <div class="ribbon-text" :class="{ 'bg-grey': item.state === 0, 'bg-deep-orange': item.state === 1, 'bg-green': item.state === 3, 'bg-black': item.state === -1 }">
            <template v-if="item.state === 0">未提交</template>
            <template v-if="item.state === 1">已提交</template>
            <template v-if="item.state === 2">待审核</template>
            <template v-if="item.state === 3">已审核</template>
            <template v-if="item.state === -1">已驳回</template>
          </div>
        </div>
      </div>
    </div>
    <div class="raise-form" v-if="raiseId">
      <transition name="slide-fade" mode="out-in">
        <raise-form-lx @submit="onSubmit" :raise-id="raiseId" v-if="raiseType === 1" />
        <raise-form-dy @submit="onSubmit" :raise-id="raiseId" v-else-if="raiseType === 2" />
        <raise-form-wx @submit="onSubmit" :raise-id="raiseId" v-else-if="raiseType === 3" />
        <raise-form-wb @submit="onSubmit" :raise-id="raiseId" v-else-if="raiseType === 4" />
        <raise-form-alipay @submit="onSubmit" :raise-id="raiseId" v-else-if="raiseType === 5" />
      </transition>
    </div>
  </div>
</template>

<script>
import { getRaises } from '@/api/project/funded'
import RaiseFormLx from './raise-form-lx'
import RaiseFormDy from './raise-form-dy'
import RaiseFormWx from './raise-form-wx'
import RaiseFormWb from './raise-form-wb'
import RaiseFormAlipay from './raise-form-alipay'

export default {
  name: 'FundedProjectRaise',
  components: {
    RaiseFormLx,
    RaiseFormDy,
    RaiseFormWx,
    RaiseFormWb,
    RaiseFormAlipay,
  },
  data() {
    return {
      tab: 'raise',
      tabs: [],
      projectId: +this.$route.query.id,
      raiseType: undefined,
      raiseId: undefined,
      raisePlatforms: ['灵析公益平台', '抖音公益平台', '腾讯公益平台', '微博公益平台', '支付宝公益平台'],
      raises: [],
    }
  },
  computed: {
    raiseTypes: vm => vm.$store.state.app.raiseTypes,
  },
  watch: {
    $route() {
      this.projectId = +this.$route.query.id
      this.load()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      }
    },
    load(init = true) {
      getRaises(this.projectId).then(({ data }) => {
        if (data.success) {
          this.raises = (data.result || []).filter(d => ![6, 7].includes(d.raiseType))
          if (init && this.raises[0]) {
            let { raiseId, raiseType } = this.raises[0]
            this.raiseType = raiseType
            this.raiseId = raiseId
          }
        }
      })
    },
    changeRaise(item) {
      this.raiseId = item.raiseId
      this.raiseType = item.raiseType
    },
    onSubmit() {
      this.load(false)
      this.$root.$emit('reloadPrj')
    },
  },
  created() {
    this.load()
  },
}
</script>

<style lang="stylus">
.raise-form
  h1, h2, h3, h4, h5, h6
    font-weight bold
    margin-top 0
    margin-bottom .65em
  p
    margin-top 0
    margin-bottom 1em
  .table-plain
    table-layout fixed
    img
      max-width 100%
</style>